import React from 'react';
import { Flex, IconButton, Button, Icon } from '@chakra-ui/react';
import { FaSun, FaMoon } from 'react-icons/fa';
import { FiLogOut } from 'react-icons/fi';
import { useAuth } from '../context/authContext';
import { useGlobalContext } from '../context/globalContext';
import SiteSwitcher from '../components/SiteSwitcher';

export default function Header() {
  const { colorMode, toggleColorMode } = useGlobalContext();
  const { logout, loading } = useAuth();

  const handleLogout = async () => {
    await logout();
    const url = new URL('/login/', window.location.origin);
    const appHome = `${import.meta.env.BASE_URL.replace(/\/?$/, '/')}`;
    url.searchParams.set('from', appHome);
    window.location.assign(url.href);
  };

  return (
    <Flex
      as='header'
      bg='global.bg'
      borderBottom='1px solid'
      borderColor='global.border'
      align='center'
      justify='flex-end'
      px={6}
      py={4}
      position='relative'
      zIndex={1}
      gap={2}
    >
      <SiteSwitcher collapsed={false} />
      <Button colorPalette='error' onClick={handleLogout} loading={loading}>
        <Icon as={FiLogOut} />
        Sign Out
      </Button>

      <IconButton aria-label='Toggle color mode' onClick={toggleColorMode}>
        <Icon as={colorMode === 'light' ? FaMoon : FaSun} />
      </IconButton>
    </Flex>
  );
}
